document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".openbtn");
  const spMenu = document.querySelector(".sp-menu");
  const menuItems = document.querySelectorAll(".sp-menu-list-item");
  const header = document.querySelector("header");
  const simSections = document.querySelectorAll(".sim-fv, .sim-under-fv");
  const body = document.body;
  const footer = document.querySelector("footer");

  /* ===========================
     SPメニュー位置調整
  ============================ */
  function updateSpMenuTop() {
    if (!header || !spMenu) return;

    const headerHeight = header.offsetHeight;
    spMenu.style.top = `${headerHeight}px`;

    simSections.forEach((section) => {
      if (window.innerWidth <= 1050) {
        section.style.setProperty("margin-top", `0px`, "important");
      } else {
        section.style.setProperty(
          "margin-top",
          `-${headerHeight}px`,
          "important"
        );
      }
    });
  }

  window.addEventListener("DOMContentLoaded", updateSpMenuTop);
  window.addEventListener("resize", updateSpMenuTop);

  /* ===========================
     ハンバーガー開閉
  ============================ */
  if (openBtn && spMenu) {
    openBtn.addEventListener("click", function () {
      this.classList.toggle("active");
      spMenu.classList.toggle("show");

      if (spMenu.classList.contains("show")) {
        body.classList.add("no-scroll");
        footer?.classList.add("z-index-3");
      } else {
        body.classList.remove("no-scroll");
        footer?.classList.remove("z-index-3");
      }
    });
  }

  /* ===========================
     親メニュークリックで開閉
  ============================ */
  menuItems.forEach((item) => {
    const parentLink = item.querySelector(":scope > a.common-anchor");
    const childList = item.querySelector(":scope > .sp-menu-child-list");

    if (!parentLink) return;

    if (childList) {
      // 子リンクがある場合 → 開閉
      parentLink.addEventListener("click", function (e) {
        e.preventDefault(); // ページ遷移防止

        const isOpen = item.classList.contains("open");

        // 他のメニューを閉じる（アコーディオン動作）
        document
          .querySelectorAll(".sp-menu-list-item.open")
          .forEach((openItem) => {
            if (openItem !== item) {
              openItem.classList.remove("open");
              openItem.querySelector("a.has-child")?.classList.remove("open");
            }
          });

        // 自分をトグル
        item.classList.toggle("open", !isOpen);
        parentLink.classList.toggle("open", !isOpen); // ← 矢印回転用
      });
    } else {
      // 子リンクなし → クリックでメニュー閉じる
      parentLink.addEventListener("click", function () {
        openBtn.classList.remove("active");
        spMenu.classList.remove("show");
        body.classList.remove("no-scroll");
      });
    }
  });

  /* ===========================
     子リンククリックでメニュー閉じる
  ============================ */
  document
    .querySelectorAll(".sp-menu-child-item a.common-anchor")
    .forEach((link) => {
      link.addEventListener("click", function () {
        openBtn.classList.remove("active");
        spMenu.classList.remove("show");
        body.classList.remove("no-scroll");
      });
    });

  // ウィンドウリサイズ時も高さ再取得
  window.addEventListener("resize", updateSpMenuTop);
});
